<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { DesktopPanelTheme, MobilePanelTheme } from ".";
import store from "@/store";

import { config } from "@/common/settings/config";

const { t } = useI18n();
const route = useRoute();

const accountId = computed(() => route.params.id as string);

const menuList = computed(() =>
  config.menu.full.map((item) => ({
    ...item,
    label: t(item.label),
  }))
);
</script>

<template>
  <template v-if="!$store.getters.mobile">
    <desktop-panel-theme :menu-list="menuList">
      <template #main>
        <slot></slot>
      </template>
    </desktop-panel-theme>
  </template>
  <template v-else>
    <mobile-panel-theme :menu-list="menuList" :account-id="accountId">
      <template #main>
        <slot></slot>
      </template>
    </mobile-panel-theme>
  </template>
</template>